import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (24.706 / 24);
  const localHeight = size * (23 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 24.706 23">
      <path
        d="M73.789,1483.528a.817.817,0,0,1-.817-.817v-10.177l-2.915-.013a.817.817,0,0,1-.549-1.418l11.257-10.36a.818.818,0,0,1,1.092-.013l11.815,10.36a.817.817,0,0,1-.535,1.431l-2.914.013v10.177a.817.817,0,0,1-.817.817Zm14.8-1.634v-10.173a.817.817,0,0,1,.813-.817l1.571-.006-9.642-8.455-9.187,8.454,1.648.007a.817.817,0,0,1,.813.817v10.173h3.731v-5.57a.817.817,0,0,1,.817-.817h4.887a.817.817,0,0,1,.817.817v5.57Zm-5.365,0v-4.753H79.971v4.753Z"
        transform="translate(-69.245 -1460.528)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
